<app-back-button/>
<div class="contents">
  <div class="page-header">
    <div class="left-area">
      <span class="title">Instituições de Ensino</span>
      <span class="sub-title">Adicione, consulte e edite instituições de ensino.</span>
    </div>
     <div class="indicator" *ngIf="instituicoesCount">
        <div class="indicator">
            <div class="icon">
                <img src="icons/building-05.svg" alt="Country Icon" />
            </div>
            <div class="text-bg">
                <span>{{instituicoesCount}} Instituições</span>
            </div>
        </div>
    </div>
  </div>

  <app-search-bar [showFilterBtn]="true" (onFilterBtnClick)="showFilterModal()" [sortFields]="sortFields"
    primaryBtnLabel="Nova Instituição" (onPrimaryBtnClick)="showDialog()"
    (formValueChange)="onFormValueChange($event)"></app-search-bar>

  <div class="list">
    <ng-container *ngIf="pagination?.data?.length; else noDataTemplate">
      <app-card-empresa *ngFor="let item of pagination.data; trackBy: trackById" [logo]="imagePreviewMap[item?.id]"
        [name]="item?.sigla" [description]="item?.nome" [country]="item?.pais" [instituicaoEnsino]="item"
        [phone]="item?.telefone" [email]="item?.email">
      </app-card-empresa>

      <div class="pagination-controls">
        <app-paginator-control [first]="((pagination.pageNumber ?? 1) - 1) * (pagination.pageSize ?? 10)"
          [rows]="pagination.pageSize ?? 10" [totalRecords]="pagination.totalRecords ?? 0"
          (pageChange)="onPageChange($event)">
        </app-paginator-control>
      </div>
    </ng-container>

    <ng-template #noDataTemplate>
      <div class="no-data">
        <app-data-void titulo="Nenhuma Instituição de ensino encontrada"
          descricao="Clique em Nova Instituição para criar uma."></app-data-void>
      </div>
    </ng-template>
  </div>

</div>
<p-toast></p-toast>

<p-dialog header="Filtros" [modal]="true" [(visible)]="showFilter" [style]="{ width: '40rem' }" appendTo="body">
  <form [formGroup]="form" class="p-fluid grid">
    <div *ngFor="let filter of filters" class="field col-6 d-flex flex-column">
      <ng-container *ngIf="filter.controlName !== 'Provincia' || form.get('tipoInstituicao')?.value === 'Interna'">
        <label>{{ filter.placeholder }}</label>

        <!-- Se for dropdown -->
        <p-select *ngIf="filter.type === 'dropdown'" [filter]="true" [showClear]="true" appendTo="body"
          [options]="filter.options" [formControlName]="filter.controlName" [placeholder]="filter.placeholder"
          [optionLabel]="filter.optionLabel" [optionValue]="filter.optionValue">
        </p-select>

        <!-- Se for texto -->
        <input *ngIf="filter.type === 'text'" pInputText [formControlName]="filter.controlName"
          [placeholder]="filter.placeholder" class="w-full" />
      </ng-container>
    </div>
  </form>

  <div class="flex items-center justify-content-between">
    <p-button label="Cancelar" severity="secondary" (click)="showFilter = false" />
    <p-button label="Pesquisar" (click)="handleFormValueChange(form.value)" />
  </div>
</p-dialog>